import axios from "axios";
import { saveAs } from "file-saver";

let self = {};

self.saveAs = saveAs;

self._getPathname = (url) => {
	let anchorTag = document.createElement("a");
	anchorTag.href = url;
	return anchorTag.pathname;
};

self._addMissingLeadingSlash = (path) => {
	return path.substr(0, 1) === "/" ? path : `/${path}`;
};

self.getRelativePath = (url) => {
	if (url) {
		const decodedUrl = decodeURIComponent(url);
		return decodedUrl && decodedUrl.includes("http")
			? self._addMissingLeadingSlash(self._getPathname(decodedUrl))
			: decodedUrl;
	}
};

self.downloadFileFromLink = async (path, absPath, fileName) => {
	const downloadPath = absPath ? path : self.getRelativePath(path);
	let res = await axios.get(downloadPath, { responseType: "blob" });
	self.saveAs(res.data, fileName);
};

export default self;
